export const FETCH_TEST_STATUS_COUNT_LOADING =
  "FETCH_TEST_STATUS_COUNT_LOADING";
export const FETCH_TEST_STATUS_COUNT_SUCCESS =
  "FETCH_TEST_STATUS_COUNT_SUCCESS";
export const FETCH_TEST_STATUS_COUNT_FAILED = "FETCH_TEST_STATUS_COUNT_FAILED";
export const SET_SELECTED_TEST_STATUS = "SET_SELECTED_TEST_STATUS";
export const CLEAR_TEST_STATUS_COUNT = "CLEAR_TEST_STATUS_COUNT";
